import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  addOrUpdateCart,
  doCartFlush,
  fetchCartList,
  removeItemFromCart,
} from "./CartApi";
import { CartState } from "../../../features/view/public/shopping/cart/CartTypes";

const initialState: CartState = {
  addTocart: {
    data: [],
    loader: false,
    billingData: {
      subtotal: 0.0,
      taxes_and_charges: 0.0,
      delivery_fee: 0.0,
      grand_total: 0.0,
      total_savings: 0.0,
      coupon_code: "",
      discount: 0.0,
    },
  },
};

export const fetchCartListAsync = createAsyncThunk(
  "cart/get/list",
  async (id: string | null) => {
    const response = await fetchCartList(id);
    return response;
  }
);
export const addOrUpdateCartAsync = createAsyncThunk(
  "cart/add",
  async (payload: any) => {
    const response = await addOrUpdateCart(payload);
    return response;
  }
);

export const removeItemFromCartAsync = createAsyncThunk(
  "cart/delete",
  async (payload: any) => {
    const response = await removeItemFromCart(payload);
    return response;
  }
);
export const cartFlushAsync = createAsyncThunk(
  "cart/flush",
  async (payload: any) => {
    const response = await doCartFlush(payload);
    return response;
  }
);

export const CartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchCartListAsync.pending, (state) => {
        state.addTocart.loader = true;
      })
      .addCase(fetchCartListAsync.fulfilled, (state, action: any) => {
        state.addTocart.loader = false;
        state.addTocart.data = action?.payload?.data?.data || [];
        state.addTocart.billingData = action?.payload?.data?.price_data || {};
      })
      .addCase(fetchCartListAsync.rejected, (state) => {
        state.addTocart.loader = false;
      })
      .addCase(addOrUpdateCartAsync.pending, (state) => {
        state.addTocart.loader = true;
      })
      .addCase(addOrUpdateCartAsync.fulfilled, (state, action: any) => {
        state.addTocart.loader = false;
        state.addTocart.data = action?.payload?.data?.data || [];
        state.addTocart.billingData = action?.payload?.data?.price_data || {};
      })
      .addCase(addOrUpdateCartAsync.rejected, (state) => {
        state.addTocart.loader = false;
      });
  },
});

export default CartSlice.reducer;
